import { Navigate, Outlet, useLocation, useMatch } from 'react-router-dom';
import { getToken } from './cookie';
import { useDrawer } from '@/hooks/DrawerHooks';
import { checkUrlLanguage, isLanguageSupported } from '@/utils/i18n.ts';

const whiteList = [
  '/login',
  '/signup',
  '/verify',
  '/setPassword',
  '/forgotpassword',
  '/setpasswordsuccess',
  '/pricing',
  '/tool',
  '/recording',
  '/share',
];
export const publicRoutes = ['/pricing', '/tool', '/recording', '/share'];

export const RequireAuth = () => {
  const { setIsOpen } = useDrawer();
  const location = useLocation();
  const isLoggedIn = getToken();
  const match = useMatch('/:lang/*');
  if (match && isLanguageSupported(match.params.lang)) {
    checkUrlLanguage(match.params.lang);
    if (!match.params['*']) {
      return <Navigate to="/home" />;
    }
  }
  if (isLoggedIn && whiteList.includes(location.pathname)) {
    const currentPath = location.pathname;
    if (currentPath === '/pricing') {
      setIsOpen(true);
      return <Navigate to="/home" />;
    }
    return publicRoutes.includes(currentPath) ? <Outlet /> : <Navigate to="/home" />;
  }

  if (!isLoggedIn && whiteList.includes(location.pathname)) {
    return <Outlet />;
  }
  return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
};
